module.exports = __webpack_public_path__ + "img/baumaschinen_otr_teaser.3070429c.jpg";